import EmptyState from '@/components/empty-state';
import { Badge } from '@/components/ui/badge';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { formatRelativeTime } from '@/lib/time';
import type { PullRequestItem } from '@/types/pull-request-item';

interface Props {
  pullRequestItems: PullRequestItem[];
  embedded?: boolean;
}

export default function PullRequestsCard({
  pullRequestItems,
  embedded = false,
}: Props) {
  const body =
    pullRequestItems.length === 0 ? (
      <EmptyState description="No attached PRs." className="py-2" />
    ) : (
      <ul className="divide-y">
        {pullRequestItems.map((item) => (
          <li key={item.id} className="py-3">
            <div className="flex flex-wrap items-center gap-2">
              <Badge variant="secondary" className="font-normal">
                {item.githubState}
              </Badge>
              <span className="text-sm font-medium">
                {item.repoFullName}#{item.number}
              </span>
            </div>
            <p className="mt-1 text-sm">{item.title}</p>
            <div className="text-muted-foreground mt-2 flex flex-wrap gap-x-3 gap-y-1 text-xs">
              <span>{formatRelativeTime(item.createdAt)}</span>
              {item.githubUrl ? (
                <a
                  href={item.githubUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-foreground underline"
                >
                  GitHub
                </a>
              ) : null}
            </div>
          </li>
        ))}
      </ul>
    );

  if (embedded) {
    return body;
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-medium">Pull requests</CardTitle>
        <CardDescription>
          GitHub PRs attached to this project. Review stays on GitHub.
        </CardDescription>
      </CardHeader>
      <CardContent>{body}</CardContent>
    </Card>
  );
}
